import { inject } from '@angular/core';
import { AuthService, LoggedInContextService } from '@ipensii/shared/data-access-shared';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggedInUserActions } from './logged-in-user.actions';
import { catchError, map, of, switchMap } from 'rxjs';

export class LoggedInUserEffects {
  private readonly actions$ = inject(Actions);
  private readonly authService = inject(AuthService);
  private readonly loggedInContextService = inject(LoggedInContextService);

  //noinspection JSUnusedLocalSymbols
  private readonly loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoggedInUserActions.loadUser),
      switchMap(() =>
        this.loggedInContextService.find().pipe(
          map((user) => LoggedInUserActions.loadUserSuccess({ user })),
          catchError((error) => of(LoggedInUserActions.loadUserError({ error })))
        )
      )
    )
  );
}
